var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.117,
    height: 18.46,
    viewBox: "0 0 16.117 18.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "help-button-speech-bubble-with-question-mark",
    transform: "translate(-38.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "live-help",
    transform: "translate(38.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M52.576,0H40.041A1.78,1.78,0,0,0,38.25,1.758V14.065a1.78,1.78,0,0,0,1.791,1.758h3.581l2.686,2.637,2.686-2.637h3.581a1.78,1.78,0,0,0,1.791-1.758V1.758A1.78,1.78,0,0,0,52.576,0ZM47.2,14.065H45.413V12.307H47.2ZM49.084,7.3l-.806.791A2.717,2.717,0,0,0,47.2,10.549H45.413v-.44a3.165,3.165,0,0,1,1.074-2.461l1.074-1.143A1.463,1.463,0,0,0,48.1,5.274a1.791,1.791,0,0,0-3.581,0H42.727a3.582,3.582,0,0,1,7.163,0A3.169,3.169,0,0,1,49.084,7.3Z",
    transform: "translate(-38.25)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help_icon.843d351027042e7c15e4ea3f8094ad0d.svg";
export { ForwardRef as ReactComponent };